<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll" style="padding-top: 50px;">
            <div class="distination-container scroll-container">
                <div class="distination-title">
                    <div class="distination-titleImg">
                        <img src="https://resource.rcclchina.com.cn/Banner/mobileDestination%20(1).jpg" alt="超凡目的地">
                    </div>
                    <div class="distination-title-txt">
                        <p>超凡目的地</p>
                        <p>探索全球精彩</p>
                    </div>
                    <div class="distination-titleBg"></div>
                </div>

                <div class="islet-content">
                    <div class="asiaIsland-container" style="display: none;">
                        <div class="asiaIsland-content swiper-container">
                            <div class="asiaIsland-allLand swiper-wrapper">
                                <div class="asisIsland-detail swiper-slide active">
                                    <div class="asiaIsland-detailTxt">亚洲</div>
                                    <div class="asiaIsland-detailImg"><img src="/Themes/RcclMobileTheme/Images/customPage/AsiaBgImg.png"></div>
                                    <div class="asiaIsland-detailBg"></div>
                                    <div class="CountryList dn">
                                        <ul>
                                            <li>
                                                <span class="countryCName">日本</span>
                                                <div class="cityListContent dn">
                                                    <ul>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=长崎" class="external">长崎</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=福冈" class="external">福冈</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=熊本" class="external">熊本</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=冲绳" class="external">冲绳</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=鹿儿岛" class="external">鹿儿岛</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=神户" class="external">神户</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=下关港" class="external">下关港</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=京都" class="external">京都</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=大阪" class="external">大阪</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=东京" class="external">东京</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=高知" class="external">高知</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=名古屋" class="external">名古屋</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=境港" class="external">境港</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=佐世保" class="external">佐世保</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=函馆" class="external">函馆</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=新潟" class="external">新潟</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=富士山(清水)" class="external">富士山(清水)</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <span class="countryCName">菲律宾</span>
                                                <div class="cityListContent dn">
                                                    <ul>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=马尼拉" class="external">马尼拉</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=长滩" class="external">长滩</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=苏比克" class="external">苏比克</a></span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <span class="countryCName">越南</span>
                                                <div class="cityListContent dn">
                                                    <ul>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=岘港(真美港)" class="external">岘港(真美港)</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=胡志明" class="external">胡志明</a></span>
                                                        </li>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=芽庄" class="external">芽庄</a></span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <span class="countryCName">俄罗斯</span>
                                                <div class="cityListContent dn">
                                                    <ul>
                                                        <li>
                                                            <span><a href="/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=海参崴" class="external">海参崴</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="asisIsland-detail swiper-slide">
                                    <div class="asiaIsland-detailTxt">欧洲</div>
                                    <div class="asiaIsland-detailImg"><img src="/Themes/RcclMobileTheme/Images/customPage/europeImg.png"></div>
                                    <div class="asiaIsland-detailBg"></div>
                                    <div class="CountryList dn">
                                        <ul>
                                            <li>
                                                <span class="countryCName">俄罗斯</span>
                                                <div class="cityListContent dn">
                                                    <ul>
                                                        <li>
                                                            <span><a href="/ShorexIntro/ShorexIntroList?cityName=海参崴" class="external">海参崴</a></span>
                                                            <img src="/Themes/RcclMobileTheme/Images/customPage/recommendImg.png">
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="asiaCountryCity-content">
                        <div class="asiaCountry-content">
                            <div class="asiaCountry-flex">
                                <div class="asiaCountry-flexContent">
                                    <ul>
                                        <li v-for="item in countryList" :key="item.id" v-bind:class="{active: activeCountryId === item.id}" @click="selectCountry(item.id)">
                                            <span class="countryCName">{{item.countryCNName}}</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="asiaCity-content">
                            <ul>
                                <li v-for="item in cityPartRecords" :key="item.id" v-bind:class="{active: activeCityId === item.id}" @click="selectCity(item.id)">
                                    <span><router-link :to="`/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${item.cityCNName}`" class="external">{{item.cityCNName}}</router-link></span>
                                    <img v-if="item.isRecommend" src="../../assets/recommendImg.png">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- 爆款推荐 -->
                <div class="shipDetail-hotCruise scroll-container" id="hotCruise">
                    <PromoCruise></PromoCruise>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    export default {
        name: 'CountryList',
        components: {
            PromoCruise
        },
        data () {
            return {
                userToken: '',
                countryList: [],
                activeCountryId: 0,
                cityPartRecords: [],
                activeCityId: 0
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '游轮目的地')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken

                const data = await this.getCountryList()
                this.countryList = data

                // 初始化
                this.activeCountryId = data[0].id
                this.cityPartRecords = data[0].cityPartRecords
                this.activeCityId = this.cityPartRecords[0].id
            },
            async getCountryList () {
                const {success, data, errMsg} = await api.page.getCountryList()
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            selectCountry (id) {
                this.activeCountryId = id
                const item = this.countryList.find(item => item.id === id)
                this.cityPartRecords = item.cityPartRecords
                this.activeCityId = this.cityPartRecords[0].id
            },
            selectCity (id) {
                this.activeCityId = id
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }

    .distination-container{
        width:100%;
        overflow-x:hidden;
    }
    .distination-container .distination-title{
        position:relative;
    }
    .distination-container .distination-title{
        width:375px;
    }
    .distination-titleImg img{
        width:100%;
        display:inherit;
    }
    .distination-title .distination-titleBg{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        background:#000;
        opacity:.2;
        z-index:1;
    }
    .distination-title .distination-title-txt{
        width:100%;
        height:54px;
        position:absolute;
        text-align:center;
        top:52px;
        color:#fff;
        font-size:18px;
        z-index:2;
        overflow:hidden;
    }
    .distination-container .islet-content{
        background:#fff;
        position:relative;
    }
    .islet-content .asiaIsland-content{
        width:355px;
        /*padding:0 10px 0 15px;*/
        height:124px;
        overflow:hidden;
        position:absolute;
        top:-50px;
        margin:0 10px;
    }
    .asiaIsland-content .asiaIsland-allLand{
        height:124px;
    }
    .asiaIsland-content .asisIsland-detail{
        width:118.5px;
        height:122px;
        overflow:hidden;
        display:inline-block;
        position:relative;
        text-align:center;
        color:#fff;
        font-size:12px;
        /*margin-left:-5px;*/
        font-weight:600;
    }
    .asiaIsland-container .swiper-button-next,
    .asiaIsland-container .swiper-button-prev{
        background-size:15px;
    }
    .asiaIsland-detailImg img{
        width:100%;
        display:inherit;
    }
    .asisIsland-detail .asiaIsland-detailTxt{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        z-index:2;
        line-height:128px;
    }
    .asisIsland-detail .asiaIsland-detailBg{
        width:100%;
        height:100%;
        position:absolute;
        top:0;
        background:#000;
        opacity:.8;
        z-index:1;
    }
    .islet-content .asiaIsland-content .active{
        color:#061556;
        font-size:14px;
    }
    .islet-content .asiaIsland-content .active .asiaIsland-detailBg{
        background:#dba41d;
    }
    .asiaIsland-content .asiaLeftImg{
        width:20px;
        position:absolute;
        left:15px;
        top:50px;
        z-index:3;
    }
    .asiaIsland-content .asiaRightImg{
        width:20px;
        position:absolute;
        top:50px;
        right:10px;
        z-index:3;
    }
    .asiaCountryCity-content .asiaCountry-content{
        text-align:center;
        border-bottom:1px solid #eaeaea;
        padding:5px 0;
    }
    .asiaCountry-content .asiaCountry-flex{
        width:355px;
        height:30px;
        margin:0 auto;
        overflow:hidden;
    }
    .asiaCountry-content .asiaCountry-flex .asiaCountry-flexContent{
        width:355px;
        height:30px;
        overflow-x:scroll;
        overflow-y:hidden;
    }
    .asiaCountryCity-content .asiaCountry-content ul{
        min-width:1000px;
        height:30px;
        display:-webkit-flex;
        display:flex;
    }
    .asiaCountryCity-content .asiaCity-content{
        text-align:left;
        padding:10px 0;
    }
    .asiaCountry-content ul,
    .asiaCity-content ul{
        display:inline-block;
        width:100%;
    }
    .asiaCountry-content ul li{
        display:inline-block;
        width:59px;
        height:25px;
        font-size:12px;
        text-align:center;
        line-height:25px;
        color:#666666;
        font-weight:600;
        /*flex:1;*/
    }
    .asiaCountry-content ul li a{
        color:#666666;
        display:inline-block;
        width:100%;
    }
    .asiaCountry-content ul li.active span {
        border-bottom: 3px solid #f9b811;
        color: #061556;
        padding-bottom: 5px;
    }
    .asiaCity-content ul li{
        position:relative;
        display:inline-block;
        width:85px;
        height:30px;
        overflow:hidden;
        font-size:12px;
        text-align:center;
        color:#777777;
        font-weight:600;
        line-height:30px;
        border-right:1px solid #c6c6c6;
    }
    .asiaCity-content ul li a{
        color:#777777;
        display:inline-block;
        width:100%;
    }
    .asiaCity-content ul li span{
        width:80px;
        height:30px;
        display:inline-block;
    }
    .asiaCity-content ul li img{
        position:absolute;
        width:15px;
        top:2px;
        right:5px;
    }

    .asiaCity-content ul li.active a {
        color: white;
    }

    .asiaCity-content ul li.active span {
        background: #f0af11;
        color: #fff;
        border-radius: 3px;
    }

    .asiaCountry-content ul li.active {

    }

    .shipDetail-hotCruise {
        margin-top: 10px;
        background: #fff;
        /* padding: 0 10px; */
    }

    /**** 爆款推荐 ****/
    .shipDetail-hotCruise {
        background-color: #fff;
    
        padding-bottom: 50px;
        margin-top:19px;
    }
</style>
